import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { StockPhrasesService } from "../../../core/services/stock-phrases.service";
import {
  EnumStockPhraseType,
  RequestStockPhraseDto,
} from "../../../core/models/orders/requestStockPhraseDto";
import { StockPhrase } from "../../../core/models/orders/stockPhrase";
import { ValidateLogin } from "../../../core/models/validate-login.dto";
import { LoaderService } from "../../../core/services/loader.service";
import { UserRole } from "../../enums/userRoles.enum";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { CommonModule } from "@angular/common";
import { SelectModule } from "primeng/select";
import { DialogModule } from "primeng/dialog";
import { TableModule } from "primeng/table";
import { MultiSelectModule } from "primeng/multiselect";
import { RadioButtonClickEvent, RadioButtonModule } from "primeng/radiobutton";
import { ButtonModule } from "primeng/button";

@UntilDestroy()
@Component({
  selector: "jni-stock-phrases",
  templateUrl: "./stock-phrases.component.html",
  styleUrls: ["./stock-phrases.component.scss"],
  imports: [
    SelectModule,
    DialogModule,
    ReactiveFormsModule,
    TableModule,
    MultiSelectModule,
    RadioButtonModule,
    CommonModule,
    FormsModule,
    ButtonModule,
    RadioButtonModule,
  ],
})
export class StockPhrasesComponent implements OnInit {
  @Input() displayPosition!: boolean;
  @Input() position!:
    | "center"
    | "top"
    | "bottom"
    | "left"
    | "right"
    | "topleft"
    | "topright"
    | "bottomleft"
    | "bottomright";
  @Input() displayModal!: boolean;
  @Input() stockListing: StockPhrase[] = [];
  @Input() selectedStock: StockPhrase[] = [];

  @Input() parent!: FormGroup;
  @Input() customerCheckbox!: boolean;
  @Input() vendorCheckbox!: boolean;
  @Input() flag = "";
  @Input() defaultType = 1;
  @Input() defaultRestriction = 2;
  @Input() customerId = "";
  @Input() vendorAccountNumber = "";
  @Output() stockPhraseSaveEvent = new EventEmitter();
  @Output() closeMainModalEvent = new EventEmitter();
  @Output() getstockPhraseEvent = new EventEmitter();
  @Output() notesAndFactEvent = new EventEmitter();

  filerStockListing: StockPhrase[] = [];
  stockPhraseForm: FormGroup;
  // vendorCheck = false;
  // customerCheck = false;
  // noneCheck = true;
  addStockPhraseCheck = "none";
  //userRoleId = 0;
  // vendorStockPhraseCheck = false;
  // customerStockPhraseCheck = false;
  stockPhraseCheck = "all";

  @Input() visibility = [
    {
      id: 1,
      name: "Global",
      status: true,
    },
    {
      id: 2,
      name: "Internal",
      status: false,
    },
  ];

  @Input() type = [
    {
      id: 1,
      name: "All",
    },
    {
      id: 2,
      name: "Order",
    },
    {
      id: 3,
      name: "OrderDescription",
    },
    {
      id: 4,
      name: "OrderFactoryNotes",
    },
  ];
  @Input() validateLoginObject = {} as ValidateLogin;

  constructor(
    private _formBuilder: FormBuilder,
    private _toastr: JniToastrService,
    private _loaderService: LoaderService,
    private _stockPhraseService: StockPhrasesService
  ) {
    this.stockPhraseForm = this._formBuilder.group({
      id: [0],
      visibility: ["", Validators.required],
      type: ["", Validators.required],
      customerAccountNumber: [""],
      vendorAccountNumber: [""],
      description: [""],
      notes: [""],
      status: ["none"],
    });
  }

  ngOnInit(): void {
    this.selectedStock = [];
    this.getLoginUser();
  }

  defaultVisibilty = 2;
  getLoginUser() {
    if (this.validateLoginObject) {
      if (this.validateLoginObject.userRoleId === UserRole.Admin) {
        this.visibility[0].status = false;
        this.defaultVisibilty = 1;
        this.defaultRestriction = this.defaultVisibilty;
      } else {
        this.visibility[0].status = true;
        this.visibility = this.visibility.filter(x => x.id !== 1); // #12938 non admin can't add Global
        this.defaultVisibilty = 2;
        this.defaultRestriction = this.defaultVisibilty;
      }
    }
  }

  showModalDialog() {
    //this.noneCheck = true;
    this.addStockPhraseCheck = "none";
    this.displayModal = true;
  }

  deleteStockPhrases() {
    if (this.selectedStock?.length) {
      this._loaderService.setLoaderState(true);
      const stockIdList = this.selectedStock.map(x => x.id);
      this._stockPhraseService
        .deleteStockPhrase(stockIdList)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.data) {
              this._toastr.success(
                "Success",
                res.message || "Stock phrase deleted successfully"
              );
              this.clearStockForm();
              this.getStockPhraseData();
              this.closeModalDialog();
            } else {
              this._toastr.error(
                "Error",
                res.message ?? "Error Occured While Deleting Stock phrase"
              );
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error(
              "Error",
              res.message ?? "Error adding stock phrase"
            );
          },
        });
    } else {
      this._toastr.error("Error", "No Stock Phrases Selected");
    }
  }

  closeModalDialog() {
    this.displayModal = false;
    // this.vendorCheck = false;
    // this.customerCheck = false;
    // this.noneCheck = true;
    this.addStockPhraseCheck = "none";
    this.clearStockForm();
  }

  clearStockForm() {
    this.stockPhraseForm.patchValue({
      id: 0,
      customerAccountNumber: "",
      vendorAccountNumber: "",
      description: "",
      notes: "",
      status: "none",
    });
  }

  getType(type: number) {
    if (type === 1) {
      return "All";
    } else if (type === 2) {
      return "Order";
    } else if (type === 3) {
      return "OrderDescription";
    } else if (type === 4) {
      return "OrderFactoryNotes";
    }
    return "";
  }

  getVisiblity(visibility: number) {
    if (visibility === 1) {
      return "Global";
    } else if (visibility === 2) {
      return "Internal";
    }
    return "";
  }

  closePositionDialog() {
    // this.vendorStockPhraseCheck = false;
    // this.customerStockPhraseCheck = false;
    this.stockPhraseCheck = "all";
    //this.noneCheck = true;
    this.addStockPhraseCheck = "none";
    this.closeMainModalEvent.emit();
  }

  getCustomerAndVendorStatus(event: RadioButtonClickEvent) {
    const value = event.value;
    this.stockPhraseForm.patchValue({
      status: value,
    });
  }

  getFilterList(event: RadioButtonClickEvent) {
    const target = event.originalEvent.target as HTMLInputElement;
    if (target?.value.toLowerCase() === "all") {
      this.getFilterStockPhrase(target?.value.toLowerCase());
    } else if (target?.value.toLowerCase() === "customer") {
      this.getFilterStockPhrase(target?.value.toLowerCase());
    } else if (target?.value.toLowerCase() === "vendor") {
      this.getFilterStockPhrase(target?.value.toLowerCase());
    }
  }

  getFilterStockPhrase(event: string) {
    if (event === "vendor") {
      this.filerStockListing = this.stockListing.filter(
        x => x.vendorAccountNumber != null
      );
    } else if (event === "customer") {
      this.filerStockListing = this.stockListing.filter(
        x => x.customerAccountNumber != null
      );
    } else {
      this.filerStockListing = this.stockListing;
    }
  }

  save() {
    const stockPhraseObject = this.stockPhraseForm.getRawValue();
    if (!stockPhraseObject.type) {
      stockPhraseObject.type = 0;
    }
    if (!stockPhraseObject.visibility) {
      stockPhraseObject.visibility = 0;
    }
    // this.vendorCheck = false;
    // this.customerCheck = false;
    stockPhraseObject.status = this.addStockPhraseCheck;
    if (this.flag) {
      stockPhraseObject.flag = this.flag;
    }
    this.onSaveStockForm(stockPhraseObject);
    //this.stockPhraseSaveEvent.emit(stockPhraseObject);
  }

  onSaveStockForm(event: StockPhrase) {
    this._loaderService.setLoaderState(true);
    if (event.status === "customer") {
      event.customerAccountNumber = this.customerId;
      event.vendorAccountNumber = null;
    } else if (event.status === "vendor") {
      event.customerAccountNumber = null;
      event.vendorAccountNumber = this.vendorAccountNumber;
    } else {
      event.customerAccountNumber = null;
      event.vendorAccountNumber = null;
    }

    this._stockPhraseService
      .createStockPhrase(event)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data) {
            this._loaderService.setLoaderState(false);
            this._toastr.success(
              "Success",
              res.message || "Stock phrase added successfully"
            );
            this.clearStockForm();
            if (event.flag === "description") {
              this.getStockPhrase(EnumStockPhraseType.OrderDescription);
            } else if (event.flag === "factory") {
              this.getStockPhrase(EnumStockPhraseType.OrderFactoryNotes);
            }
            // this.stockPhraseDescription.closeModalDialog();
            // this.stockPhraseFactory.closeModalDialog();
            this.closeModalDialog();
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error(
            "Error",
            res.message || "Error adding stock phrase"
          );
        },
      });
  }

  addFieldData() {
    this.notesAndFactEvent.emit(this.selectedStock);
  }

  getStockPhraseData() {
    if (this.flag === "description") {
      this.getStockPhrase(EnumStockPhraseType.OrderDescription);
    } else if (this.flag === "factory") {
      this.getStockPhrase(EnumStockPhraseType.OrderFactoryNotes);
    }
  }

  getStockPhrase(type: number) {
    this._loaderService.setLoaderState(true);
    const stockPhraseType = [] as EnumStockPhraseType[];
    stockPhraseType.push(EnumStockPhraseType.All);
    stockPhraseType.push(EnumStockPhraseType.Order);
    stockPhraseType.push(type);

    const getStockObject: RequestStockPhraseDto = {
      types: stockPhraseType,
      customerAccountNumber: this.customerId === "" ? null : this.customerId,
      vendorAccountNumber:
        this.vendorAccountNumber === "" ? null : this.vendorAccountNumber,
    };
    this._stockPhraseService
      .getStockPhrase(getStockObject)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.length > 0) {
            this.stockListing = res;
            this.filerStockListing = res;
          } else {
            this.stockListing = [];
            this.filerStockListing = [];
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "Data not found");
        },
      });
  }
}
